<!--
 * @Description: 个人 综合绩效
 * @Author: maqinghe 
 * @Date: 2023年06月09日 13:04:22
-->
<template>
    <div class='personal-workscore atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList" @submit.native.prevent>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-tabs" v-if="false">
        <div
          class="table-tab"
          v-for="tab in tabs"
          :class="{'table-tab--active': currentTab === tab.value}"
          @click="switchTab(tab.value)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class='table-content' v-show="currentTab === 0">
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="100" title="姓名"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span v-if="(row.category === 'Month' && row.workScoreInfo) || (row.category === 'Year' && row.yearScoreInfo)" class="link-col" @click="toPage(row)">{{ row.year }}{{ periods[row.period] }}</span>
              <span v-else>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" width="100" title="总成绩"></vxe-table-column>
          <vxe-table-column field="ratingResult" title="评定结果" min-width="100">
            <template #default="{ row }">
              <el-tag
                title="A"
                v-if='row.ratingResult === "A"'
                type="success"
                size="medium"
                effect="plain">
                A
              </el-tag>
               <el-tag
                title="B"
                v-if='row.ratingResult === "B"'
                type="info"
                size="medium"
                effect="light">
                B
              </el-tag>
               <el-tag
                title="C"
                v-if='row.ratingResult === "C"'
                type="danger"
                size="medium"
                effect="plain">
                C
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingReason" title="评定原因" min-width="160">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="130">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <!-- 年计划考核 -->
      <div class='table-content' v-show="currentTab === 1">
        <div class="collapse" @click="yearCollapse($refs.table1)" :style="{'right': yearCollapseRight}">
          <i :class="[isYearCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table1"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="100" title="姓名"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span v-if="row.yearScoreInfo" class="link-col" @click="toPage(row)">{{ row.year }}{{ periods[row.period] }}</span>
              <span v-else>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" width="100" title="总成绩"></vxe-table-column>
          <vxe-table-column field="ratingResult" title="评定结果" min-width="100">
            <template #default="{ row }">
              <el-tag
                title="A"
                v-if='row.ratingResult === "A"'
                type="success"
                size="medium"
                effect="plain">
                A
              </el-tag>
               <el-tag
                title="B"
                v-if='row.ratingResult === "B"'
                type="info"
                size="medium"
                effect="light">
                B
              </el-tag>
               <el-tag
                title="C"
                v-if='row.ratingResult === "C"'
                type="danger"
                size="medium"
                effect="plain">
                C
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingReason" title="评定原因" min-width="160"></vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="130"></vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify0" width="110" title="重要KPI成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify0}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify10" width="100" title="业务成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify10}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify20" width="110" title="费效管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify20}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify30" width="150" title="人力资源管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify30}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify40" width="150" title="企业文化管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify40}}</div>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>

      <!-- 员工绩效参考 -->
      <div class='table-content' v-show="currentTab === 2">
        <div class="collapse" @click="personCollapse($refs.table2)" :style="{'right': personCollapseRight}">
          <i :class="[isPersonCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table2"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="100" title="姓名"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span v-if="row.workScoreInfo" class="link-col" @click="toPage(row)">{{ row.year }}{{ periods[row.period] }}</span>
              <span v-else>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" width="100" title="总成绩"></vxe-table-column>
          <vxe-table-column field="ratingResult" title="评定结果" min-width="100">
            <template #default="{ row }">
              <el-tag
                title="A"
                v-if='row.ratingResult === "A"'
                type="success"
                size="medium"
                effect="plain">
                A
              </el-tag>
               <el-tag
                title="B"
                v-if='row.ratingResult === "B"'
                type="info"
                size="medium"
                effect="light">
                B
              </el-tag>
               <el-tag
                title="C"
                v-if='row.ratingResult === "C"'
                type="danger"
                size="medium"
                effect="plain">
                C
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingReason" title="评定原因" min-width="160"></vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="130"></vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify100" width="80" title="绩效成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify100}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify110" width="80" title="企业文化导向成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify110}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify120" width="80" title="个人成长成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify120}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify130" width="80" title="OEC综合成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify130}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-for="col in monthColumns"
            :field="col.field"
            :width="col.width"
            :title="col.title"
            :fixed="col.fixed"
            :visible="isShowPerson"
            :key="col.field"
          >
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          v-show="currentTab === 0"
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 1"
          background
          :current-page.sync="yearPage.pageIndex"
          :page-size.sync="yearPage.pageSize"
          :total="yearTotal"
          height="100%"
          @page-change="yearPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 2"
          background
          :current-page.sync="personPage.pageIndex"
          :page-size.sync="personPage.pageSize"
          :total="personTotal"
          height="100%"
          @page-change="personPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
</template>
<script>
  import _ from 'lodash';
  import {
    CLASSIFY_MAP,
    PERIODS,
  } from '@/utils/period-enum.js';

  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    name: "resultSearch",
    inject: ['reload'],
    props: {
      isActive: Boolean,
    },
    data() {
      return {
        tabs: [
          { name: '全部', value: 0, key: 'all', category: '' },
          { name: '年计划考核', value: 1, key: 'year', category: 'Year' },
          { name: '员工绩效考核', value: 2, key: 'person', category: 'Month' },
        ],
        currentTab: 0,
        isYearCollapse: true,
        isPersonCollapse: true,
        yearCollapseRight: 0,
        personCollapseRight: 0,

        classifyMap: CLASSIFY_MAP,
        
        periods: PERIODS,

        categoryList: [
          {label: '年计划考核', value: 'Year' },
          {label: '员工绩效考核', value: 'Month' },
        ],

        searchParam: {
          year: ''
        },
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],

        yearPage: {
          pageIndex: 1,
          pageSize: 10
        },
        yearTotal: 0,

        personPage: {
          pageIndex: 1,
          pageSize: 10
        },
        personTotal: 0,

        warnNum: 'warn-num',
        nomalNum: 'num',

        currWkNo: '',
        wkNo: '',
        msgId: '',
        role: 1,
        status: '',

        isShowYearPlan: false,
        isShowPerson: false,
        monthColumns: [
          {field: 'm1', title: '1月',  width: 50, fixed: 'right'},
          {field: 'm2', title: '2月',  width: 50, fixed: 'right'},
          {field: 'm3', title: '3月',  width: 50, fixed: 'right'},
          {field: 'm4', title: '4月',  width: 50, fixed: 'right'},
          {field: 'm5', title: '5月',  width: 50, fixed: 'right'},
          {field: 'm6', title: '6月',  width: 50, fixed: 'right'},
          {field: 'm7', title: '7月',  width: 50, fixed: 'right'},
          {field: 'm8', title: '8月',  width: 50, fixed: 'right'},
          {field: 'm9', title: '9月',  width: 50, fixed: 'right'},
          {field: 'm10', title: '10月',  width: 60, fixed: 'right'},
          {field: 'm11', title: '11月',  width: 60, fixed: 'right'},
          {field: 'm12', title: '12月',  width: 60, fixed: 'right'},
        ],

        classifyPrefix: 'classify',

      }
    },
    watch: {
      $route(){
        this.reload();
      },
      isActive(newVal) {
        if (newVal && this.tableData.length === 0) {
          this.getList();
        }
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      this.date = this.$route.query.date || '';
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      if (this.isActive) {
        this.getList();
      }
    },
    methods: {
      switchTab(tabIndex) {
        this.currentTab = tabIndex;
        this.getList();
      },
      yearCollapse(el) {
        this.isYearCollapse = !this.isYearCollapse;
        if (this.isYearCollapse) {
          this.hideYearPlan();
        } else {
          this.showYearPlan();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setYearPosition();
        });
      },
      showYearPlan() {
        this.isShowYearPlan = true;
      },
      hideYearPlan() {
        this.isShowYearPlan = false;
      },
      setYearPosition() {
        setTimeout(() => {
          if (this.isYearCollapse) {
            this.yearCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table1.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.yearCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      personCollapse(el) {
        this.isPersonCollapse = !this.isPersonCollapse;
        if (this.isPersonCollapse) {
          this.hidePerson();
        } else {
          this.showPerson();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setPersonPosition();
        });
      },
      showPerson() {
        this.isShowPerson = true;
      },
      hidePerson() {
        this.isShowPerson = false;
      },
      setPersonPosition() {
        setTimeout(() => {
          if (this.isPersonCollapse) {
            this.personCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table2.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.personCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      async getList(resetPage) {
        if (resetPage) {
          this.page.pageIndex = 1;
        }
        if (this.wkNo) {
          this.currWkNo = this.wkNo;
        }
        let page = this.page;
        switch (this.currentTab) {
          case 0:
            page = this.page;
            break;
          case 1:
            page = this.yearPage;
            break;
          case 2:
            page = this.personPage;
            break;
          default:
            break;
        }
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        let param = Object.assign({loginWkNo: this.currWkNo, category, year: this.searchParam.year || undefined }, page);
        await this.$ajax.post(this.$api.period.oecWorkScore.list, param).then(async (res) => {
          let resList = res.data.rows || [];
          resList = resList.map(p => {
            p.parentId = null;
            p.hasChild = p.isOrLeader ? true : false;
            return p;
          });
          let tableDatas = [];
          resList.forEach(item => {
            let rowData = {
              ...item.periodResultInfo,
              ...item,
            };
            let monthData = item.oecResultInfo || [];

            for (let i = 0; i < this.monthColumns.length; i++) {
              rowData[this.monthColumns[i]] = '';
            }
            monthData.forEach(p => {
              rowData['m' + p.month] = p.ratingResult || '';
            });

            let classifyData = item.periodClassifyScoreInfo || [];
            for (const key in this.classifyMap) {
              rowData[this.classifyPrefix + key] = '';
            }
            classifyData.forEach(c => {
              rowData[this.classifyPrefix + c.workClassify] = c.score;
            });

            tableDatas.push(rowData);
          });
          this.tableData = tableDatas;
          
          switch (this.currentTab) {
            case 0:
              this.total = res.data.total;
              break;
            case 1:
              this.yearTotal = res.data.total;
              break;
            case 2:
              this.personTotal = res.data.total;
              break;
            default:
              break;
          }
        });
      },


      pageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      yearPageChange({currentPage}) {
        this.yearPage.pageIndex = currentPage;
        this.getList();
      },
      personPageChange({currentPage}) {
        this.personPage.pageIndex = currentPage;
        this.getList();
      },
      exportExcel(){
        const params = {Year: this.searchParam.year || undefined};
  
        this.$ajax.get(this.$api.period.oecWorkScore.export, params, {ignore: true, responseType:'blob'}).then((res)=>{
          if(res.data.type == 'application/json'){
            var reader = new FileReader();
            reader.onload = ()=>{
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          }else{
            const filename ='个人OEC-综合绩效'
            const filetype ='xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }).catch(() => {})
      },

      toPage(row) {
        if (row.category === 'Month') {
          this.$router.push({path: '/personal/workscore/detail', query: { id: row.workScoreInfo.id, editStatus: 'edit' }});
        } else if (row.category === 'Year') {
          this.$router.push({path: '/personal/workscore/yearDetail', query: { id: row.yearScoreInfo.id, editStatus: 'edit' }});
        }
      },

      expandRow({ row, rowIndex }) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.table.updateData(this.tableData);
      },
    },
  }
</script>
<style scoped lang='scss'>
  .table-content {
    position: relative;
  }
  .personal-workscore {
    height: 100%;
  }
  .el-date-editor--daterange.el-input__inner {
    width: 400px;
    border-radius: 10px;
  }
  ::v-deep .tab {
    margin-top: -3px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
  .collapse {
    margin-top: -15px;
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: rgba(#000, 0.1);
    z-index: 99;
    cursor: pointer;
    &:hover {
      background-color: rgba(#000, 0.2);
    }
    i {
      font-size: 14px;
      color: #fff;
    }
  }
  .table-tabs {
    .table-tab {
      display: inline-block;
      margin: 8px;
      padding: 8px 10px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid $--color-primary;
      background-color: #d8f5f1;
      color: $--color-primary;
      &:hover, &.table-tab--active {
        background-color: $--color-primary;
        color: #fff;
      }
    }
    
  }
  .link-col {
    cursor: pointer;
    color: $--color-primary;
  }
</style>